import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme: any) => ({
  root: {
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  width100: {
    width: '100%'
  },
  list: {
    width: '100%'
  }
}));
